<template>
  <q-page padding>
    <q-card-section>
      <q-form ref="myForm">
        <div class="row">
          <UploadComponentImagem
            :uuid="id"
            :upar="upar"
            @atualizar="listarFerramentas((selecionaImagem = false))"
          />
          <div
            class="row col-9 q-col-gutter-sm mobile2 text-brand-5 text-weight-bold"
          >
            <div class="col-sm-3">
              Unidade
              <lista-unidades-select v-model="unidade"></lista-unidades-select>
            </div>
            <div class="col-sm-3">
              Código
              <q-input dense outlined v-model="ferramenta.nome"> </q-input>
            </div>
            <div class="col-md-3">
              Descrição da Ferramenta
              <q-input dense outlined v-model="ferramenta.descricao"> </q-input>
            </div>
            <div class="col-md-3">
              <SelectComponentGrupos
                @emitirGrupo="receberDadosGrupo"
                :subGrupoCategoriaUuid="subGrupo.categoriaUuid"
                :resetar="resetar"
              />
            </div>
            <div class="col-md-3">
              <SelectComponentSubGrupos
                @emitirSubGrupo="receberDadosSubGrupo"
                :categoriaUuid="ferramenta.grupo"
                :resetar="resetar"
              />
            </div>
            <div class="col-md-3">
              <SelectComponentFornecedores
                @emitirFornecedor="receberDadosFornecedor"
                :reset="atualizar"
              />
            </div>
            <div class="col-md-3 col-sm-6 col-xs-6">
              Série
              <q-input dense outlined v-model="ferramenta.serie"> </q-input>
            </div>

            <div class="col-md-3 col-sm-6 col-xs-6">
              Valor Equipamento
              <q-input
                dense
                mask="#,##"
                reverse-fill-mask
                outlined
                v-model="ferramenta.preco"
              >
              </q-input>
            </div>

            <div class="col-md-3 col-sm-12 col-xs-12">
              N. Patrimônio
              <q-input
                dense
                outlined
                v-model="ferramenta.patrimonio"
                type="text"
              >
              </q-input>
            </div>
            <div class="col-md-3 col-sm-3">
              N. Documento
              <q-input dense outlined v-model="ferramenta.documento"> </q-input>
            </div>
            <div class="col-sm-3">
              Tempo de Permanência
              <q-input
                dense
                outlined
                v-model="ferramenta.permanencia"
                type="number"
              >
              </q-input>
            </div>
            <div class="col-md-3">
              Valor Locação
              <q-input
                mask="#,##"
                reverse-fill-mask
                dense
                outlined
                v-model="ferramenta.valorLocacao"
              >
              </q-input>
            </div>
            <div class="col-md-3">
              Selecione o Responsável
              <SelectComponentResponsaveis
                @emitirFuncionario="receberDadosFuncionario"
                :resetar="resetar"
              />
            </div>
            <div class="col-md-3">
              <SelectComponentTipoDocumento
                @enviarTipoDocumento="receberDadosDocumento"
                :resetar="resetar"
              />
            </div>

            <div class="col-5">
              <div>Origem</div>
              <div class="row q-gutter-sm">
                <q-radio
                  v-model="ferramenta.origem"
                  val="propria"
                  label="Própria"
                ></q-radio>
                <q-radio
                  v-model="ferramenta.origem"
                  val="locada"
                  label="Locada"
                ></q-radio>
                <q-radio
                  v-model="ferramenta.origem"
                  val="consumo"
                  label="Consumo"
                ></q-radio>
              </div>
            </div>

            <div class="col-md-3 col-sm-12 col-xs-12">
              <p></p>
              <q-btn
                class="q-mt-sm full-width"
                color="positive"
                label="Adicionar"
                no-caps
                type="submit"
                icon="add"
                @click.prevent="criar()"
              />
            </div>
          </div>
        </div>
      </q-form>
    </q-card-section>

    <div class="q-ml-md">
      <upload-component
        :titulo="'Enviar planilha de produtos'"
        :template="'ferramenta'"
        :deletar="true"
      />
    </div>

    <div class="row col-12 q-mt-lg">
      <p
        class="text-h6 self-end q-pl-md q-mt-lg text-brand-5 text-weight-medium"
      >
        Ferramentas
      </p>
    </div>

    <div class="row">
      <q-btn
        class="q-mt-lg q-ml-lg"
        no-caps
        icon="browser_updated"
        color="secondary"
        type="a"
        label="Baixar Template"
        href="https://multpex-docs.s3.amazonaws.com/templates/ferramentas/ferramentas_r3.xlsx"
        target="_blank"
      />

      <q-btn
        class="q-mt-lg q-ml-lg"
        no-caps
        icon="browser_updated"
        color="secondary"
        type="a"
        label="Baixar Template Exclusão"
        href="https://multpex-docs.s3.amazonaws.com/templates/ferramentas/ferramenta-delete.xlsx"
        target="_blank"
      />
    </div>
    <div class="row col-12 justify-end q-mt-xl q-gutter-sm">
      <div class="col-md-2">
        <SelectComponentGrupos
          @emitirGrupo="receberDadosGrupoFiltro"
          :subGrupoCategoriaUuid="subGrupoFiltro?.categoria_uuid"
          :label="'Grupo'"
          :rounded="true"
        />
      </div>
      <div class="col-md-2">
        <SelectComponentSubGrupos
          @emitirSubGrupo="receberDadosSubGrupoFiltro"
          :categoriaUuid="grupoFiltro?.uuid"
          :label="'Sub Grupo'"
          :rounded="true"
        />
      </div>
      <div class="col-md-2">
        <q-input
          rounded
          outlined
          dense
          v-model="patrimonio"
          type="text"
          placeholder="Patrimônio"
        >
        </q-input>
      </div>
      <div class="col-md-2">
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtraFerramenta"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
    </div>
    <q-table
      grid
      :columns="columns"
      :rows="listaFerramentas"
      row-key="uuid"
      dense
      hide-pagination
      v-model:pagination="pagination"
      :loading="disable"
    >
      <template v-slot:item="props">
        <div class="q-pa-sm col-xs-12 col-sm-4 col-md-3">
          <q-card class="my-card">
            <div v-if="props.row.url">
              <q-img
                :src="props.row.url"
                class="row border-img"
                spinner-color="white"
                height="100%"
                fit="contain"
                no-native-menu
              >
              </q-img>
              <div
                style="width: 100%"
                class="absolute row col-12 justify-between items-center"
              >
                <q-icon
                  size="16px"
                  color="black"
                  class="absolute all-pointer-events row cursor"
                  style="bottom: 8px; left: 8px; z-index: 30"
                  name="edit"
                  @click="editar(props.row.uuid)"
                ></q-icon>
                <div
                  v-if="
                    props.row.status == 'manutencao' ||
                    props.row.status == 'manutencao_garantia' ||
                    props.row.status == 'reativacao' ||
                    props.row.status == 'desmobilizada' ||
                    props.row.status == 'retorno_em_garantia' ||
                    props.row.status == 'aguardando_reparo'
                  "
                  style="background: transparent; margin-bottom: 14px"
                  class="absolute-bottom"
                >
                  <q-icon
                    size="16px"
                    color="green"
                    name="sync"
                    class="all-pointer-events row cursor absolute-center"
                    @click="movimentarStatus(props.row.uuid)"
                  ></q-icon>
                </div>
                <q-icon
                  class="absolute all-pointer-events cursor"
                  size="16px"
                  color="red"
                  style="bottom: 8px; right: 16px"
                  name="delete"
                  @click="receberDadosRemoverFerramenta(props.row)"
                ></q-icon>
              </div>
            </div>

            <q-img
              v-else
              src="../../../assets/semImagem.jpg"
              class="border-img"
              no-native-menu
              fit="contain"
            >
              <router-link
                :to="{
                  name: 'editarFerramenta',
                  params: { uuid: props.row.uuid },
                }"
              >
                <q-icon
                  size="16px"
                  color="black"
                  class="absolute all-pointer-events row cursor"
                  style="bottom: 8px; left: 8px; z-index: 30"
                  name="edit"
                ></q-icon>
              </router-link>
              <div
                v-if="
                  props.row.status == 'manutencao' ||
                  props.row.status == 'manutencao_garantia' ||
                  props.row.status == 'reativacao' ||
                  props.row.status == 'desmobilizada' ||
                  props.row.status == 'retorno_em_garantia' ||
                  props.row.status == 'aguardando_reparo'
                "
                style="background: transparent"
                class="absolute-bottom"
              >
                <q-icon
                  size="16px"
                  color="green"
                  class="all-pointer-events row cursor absolute-center"
                  style="bottom: 1px"
                  name="sync"
                  @click="movimentarStatus(props.row.uuid)"
                ></q-icon>
              </div>
              <q-icon
                class="absolute all-pointer-events cursor"
                size="16px"
                color="red"
                style="bottom: 8px; right: 8px"
                name="delete"
                @click="receberDadosRemoverFerramenta(props.row)"
              ></q-icon>
            </q-img>

            <q-card-section
              horizontal
              class="row text-rigth text-weight-regular text-body2"
            >
              <div class="column">
                <div class="q-mb-sm">
                  <span v-if="props.row.nome?.length < 30">
                    {{ props.row.nome }}
                  </span>
                  <span v-else>
                    {{ `${props.row.nome?.substring(0, 30)}...` }}
                    <q-tooltip>{{ props.row.nome }}</q-tooltip>
                  </span>
                </div>
                <div class="q-mb-sm">
                  <span v-if="props.row.descricao?.length < 20">
                    {{ props.row?.descricao }}
                  </span>
                  <span v-else>
                    {{
                      props.row.descricao != null
                        ? `${props.row.descricao?.substring(0, 20)}...`
                        : ""
                    }}
                    <q-tooltip>{{
                      props.row.descricao != null ? props.row?.descricao : ""
                    }}</q-tooltip>
                  </span>
                </div>
                <div class="q-mb-sm">
                  <span v-if="props.row.categoria_nome?.length < 20">
                    <strong>Grupo:</strong> {{ props.row?.categoria_nome }}
                  </span>
                  <span v-else>
                    <strong>Grupo:</strong>
                    {{
                      props.row.categoria_nome != null
                        ? `${props.row.categoria_nome?.substring(0, 20)}...`
                        : ""
                    }}
                    <q-tooltip>{{
                      props.row.categoria_nome != null
                        ? props.row?.categoria_nome
                        : ""
                    }}</q-tooltip>
                  </span>
                </div>
                <div class="q-mb-sm">
                  <span v-if="props.row.grupo_ferramenta_nome?.length < 20">
                    <strong>Sub Grupo:</strong>
                    {{ props.row?.grupo_ferramenta_nome }}
                  </span>
                  <span v-else>
                    <strong>Sub Grupo:</strong>
                    {{
                      props.row.grupo_ferramenta_nome != null
                        ? `${props.row.grupo_ferramenta_nome?.substring(
                            0,
                            20
                          )}...`
                        : ""
                    }}
                    <q-tooltip>{{
                      props.row.grupo_ferramenta_nome != null
                        ? props.row?.grupo_ferramenta_nome
                        : ""
                    }}</q-tooltip>
                  </span>
                </div>

                <span>
                  <q-icon size="sm" name="attach_money" />{{ props.row.preco }}
                  <q-icon class="q-pl-sm" size="sm" name="domain" />
                  <strong>N Patri:</strong> {{ props.row.patrimonio }}</span
                >

                <span class="q-pt-sm q-mb-sm">
                  <q-icon size="sm" name="schedule" />
                  <strong>Temp Perma:</strong
                  >{{ props.row.tempoPermanencia }}m</span
                >
                <div class="row items-center">
                  <span class="q-mr-sm"><strong>Status:</strong></span>
                  <div
                    :style="
                      props.row.status == 'disponivel'
                        ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                        : props.row.status == 'manutencao_garantia'
                        ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                        : props.row.status == 'uso'
                        ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                        : props.row.status == 'manutencao'
                        ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                        : props.row.status == 'em_transito'
                        ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                        : props.row.status == 'removida' ||
                          props.row.status == 'calibracao'
                        ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                        : props.row.status == 'retorno_em_garantia'
                        ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                        : props.row.status == 'desmobilizada'
                        ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                        : props.row.status == 'reativacao'
                        ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                        : props.row.status == 'descartada'
                        ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                        : props.row.status == 'sucata'
                        ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                        : props.row.status == 'furto'
                        ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                        : props.row.status == 'aguardando_reparo'
                        ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                        : props.row.status == 'aguardando_calibracao'
                        ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                        : ''
                    "
                    class="row col-12 no-wrap align items-center"
                  >
                    <span
                      v-if="props.row.status == 'disponivel'"
                      class="elipse q-mr-sm bg-positive"
                    ></span>
                    <span
                      v-if="props.row.status == 'uso'"
                      class="elipse q-mr-sm bg-warning"
                    ></span>
                    <span
                      v-if="props.row.status == 'manutencao_garantia'"
                      class="elipse q-mr-sm"
                      style="background: #424242"
                    ></span>
                    <span
                      v-if="props.row.status == 'manutencao'"
                      class="elipse q-mr-sm bg-red"
                    ></span>
                    <span
                      v-if="props.row.status == 'em_transito'"
                      class="elipse q-mr-sm"
                      style="background: #2d3e6e"
                    ></span>
                    <span
                      v-if="props.row.status == 'removida'"
                      class="elipse q-mr-sm"
                      style="background: #383737"
                    ></span>
                    <span
                      v-if="props.row.status == 'retorno_em_garantia'"
                      class="elipse q-mr-sm"
                      style="background: #383737"
                    ></span>
                    <span
                      v-if="props.row.status == 'desmobilizada'"
                      class="elipse q-mr-sm"
                      style="background: #fa9726"
                    ></span>
                    <span
                      v-if="props.row.status == 'reativacao'"
                      class="elipse q-mr-sm"
                      style="background: #473fe8"
                    ></span>
                    <span
                      v-if="props.row.status == 'descartada'"
                      class="elipse q-mr-sm"
                      style="background: #b0cde8"
                    ></span>
                    <span
                      v-if="props.row.status == 'sucata'"
                      class="elipse q-mr-sm"
                      style="background: #736d6a"
                    ></span>
                    <span
                      v-if="props.row.status == 'furto'"
                      class="elipse q-mr-sm"
                      style="background: #6b1215"
                    ></span>
                    <span
                      v-if="props.row.status == 'aguardando_reparo'"
                      class="elipse q-mr-sm"
                      style="background: #fa9726"
                    ></span>
                    <span
                      v-if="props.row.status == 'calibracao'"
                      class="elipse q-mr-sm"
                      style="background: #383737"
                    ></span>
                    <span
                      v-if="props.row.status == 'aguardando_calibracao'"
                      class="elipse q-mr-sm"
                      style="background: #11009e"
                    ></span>
                    <div
                      v-if="props.row.status == 'disponivel'"
                      style="width: fit-content; background: #e8ffec"
                      class="text-brand-5 text-bold"
                    >
                      {{ "Disponível" }}
                    </div>
                    <div
                      v-if="props.row.status == 'uso'"
                      style="width: fit-content; background: #fefed1"
                      class="text-brand-5 text-bold"
                    >
                      {{ "Em Uso" }}
                    </div>
                    <div
                      v-if="props.row.status == 'manutencao_garantia'"
                      style="width: fit-content"
                      class="text-brand-5 text-bold"
                    >
                      {{ "Manutenção Garantia" }}
                    </div>
                    <div
                      v-if="props.row.status == 'manutencao'"
                      style="width: fit-content"
                      class="text-red text-bold"
                    >
                      {{ "Manutenção" }}
                    </div>
                    <div
                      v-if="props.row.status == 'em_transito'"
                      style="width: fit-content; color: #192957"
                      class="text-bold"
                    >
                      {{ "Em Trânsito" }}
                    </div>
                    <div
                      v-if="props.row.status == 'removida'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Removida" }}
                    </div>
                    <div
                      v-if="props.row.status == 'retorno_em_garantia'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Retorno Em Garantia" }}
                    </div>
                    <div
                      v-if="props.row.status == 'desmobilizada'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Desmobilizada" }}
                    </div>
                    <div
                      v-if="props.row.status == 'reativacao'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Reativação" }}
                    </div>
                    <div
                      v-if="props.row.status == 'descartada'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Descartada" }}
                    </div>
                    <div
                      v-if="props.row.status == 'sucata'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Sucata" }}
                    </div>
                    <div
                      v-if="props.row.status == 'furto'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Furto" }}
                    </div>
                    <div
                      v-if="props.row.status == 'aguardando_reparo'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Aguardando Reparo" }}
                    </div>
                    <div
                      v-if="props.row.status == 'calibracao'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Calibração" }}
                    </div>
                    <div
                      v-if="props.row.status == 'aguardando_calibracao'"
                      style="width: fit-content"
                      class="text-bold"
                    >
                      {{ "Aguardando Calibração" }}
                    </div>
                  </div>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>

    <div class="q-mt-md row justify-start">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <q-dialog v-model="FerramentaExcluirModal">
      <q-card>
        <q-card-section>
          <div class="text-h6 text-brand-5 text-weight-bold">Aviso</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <span class="text-bold text-brand-5">{{
            `DESEJA EXCLUIR A FERRAMENTA: ${ferramentaExcluir.nome} ?`
          }}</span>
        </q-card-section>

        <q-card-actions class="row col-12 justify-between">
          <q-btn flat label="Cancelar" no-caps color="red" v-close-popup />
          <q-btn
            flat
            label="OK"
            no-caps
            color="positive"
            v-close-popup
            @click="deletar()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import SelectComponentGrupos from "../components/SelectComponentGrupos.vue";
import SelectComponentSubGrupos from "../components/SelectComponentSubGrupos.vue";
import SelectComponentResponsaveis from "../components/SelectComponentResponsaveis.vue";
import SelectComponentFornecedores from "../components/SelectComponentFornecedores.vue";
import UploadComponentImagem from "../components/UploadComponentImagem.vue";
import UploadComponent from "../components/UploadComponent.vue";
import SelectComponentTipoDocumento from "../components/SelectComponentTipoDocumento.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  name: "CadastrarFerramentas",
  components: {
    SelectComponentGrupos,
    SelectComponentSubGrupos,
    SelectComponentResponsaveis,
    SelectComponentFornecedores,
    UploadComponentImagem,
    UploadComponent,
    SelectComponentTipoDocumento,
    ListaUnidadesSelect,
  },
  setup() {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });

    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });

    const upar = ref(0);
    const id = ref("");
    const atualizar = ref(0);
    let resetar = ref(0);
    const patrimonio = ref("");
    let unidade = ref("");
    const ferramenta = ref({
      uuid: "",
      nome: "",
      descricao: "",
      imagem: "",
      grupo: "",
      serie: "",
      patrimonio: "",
      fornecedorId: "",
      documento: "",
      preco: "",
      responsavelId: "",
      responsavelNome: "",
      origem: "",
      permanencia: "",
      status: "",
      tipo_documento: "",
      valorLocacao: "",
    });

    const subGrupo = ref({
      uuid: "",
      categoriaUuid: "",
    });
    const ferramentaExcluir = ref("");
    const listaFerramentas = ref([]);
    const $q = useQuasar();
    const myForm = ref(null);
    const store = useStore();
    const router = useRouter();
    const filtraFerramenta = ref("");
    const disable = ref(true);
    const grupoFiltro = ref({
      descricao: "",
      uuid: "",
      nome: "",
    });
    const subGrupoFiltro = ref({
      uuid: "",
      nome: "",
      categoria_uuid: "",
      descricao: "",
    });
    let FerramentaExcluirModal = ref(false);

    let upload = async (uuid) => {
      ferramenta.value.uuid = uuid;
    };

    let receberDadosGrupo = async (value) => {
      ferramenta.value.grupo = value.uuid;
      if (value === "") {
        subGrupo.value.categoriaUuid = "";
        resetar.value++;
      }
    };

    let receberDadosSubGrupo = async (value) => {
      subGrupo.value.uuid = value.uuid;
      subGrupo.value.categoriaUuid = value.categoria_uuid;
    };

    let receberDadosFornecedor = async (value) => {
      ferramenta.value.fornecedorId = value.value.id;
    };

    let receberDadosFuncionario = async (value) => {
      ferramenta.value.responsavelId = value.id;
      ferramenta.value.responsavelNome = value.nome;
    };

    const receberDadosDocumento = async (value) => {
      ferramenta.value.tipo_documento = value;
    };

    const editar = async (uuid) => {
      router.push({ name: "editarFerramenta", params: { uuid } });
    };

    let deletar = async () => {
      try {
        await store.dispatch("fer/deletarFerramenta", {
          uuid: ferramentaExcluir.value.uuid,
        });
        mensagem("Ferramenta excluida com sucesso!");
        listarFerramentas();
      } catch (error) {
        if (
          error.response.data.result.error ===
          `A ferramenta '${ferramentaExcluir.value.uuid}' contem movimentacao`
        ) {
          $q.notify({
            message:
              "A ferramenta contem movimentação e não poderá ser deletada",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        $q.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    let deletarImagem = async (uuid, nome) => {
      let resposta = confirm(`Deseja excluir a imagem de ${nome}? `);
      if (resposta == true) {
        await store.dispatch("fer/deletarImagem", {
          uuid: uuid,
        });

        mensagem("Imagem excluida com sucesso!");
        listarFerramentas();
      }
    };

    let mensagem = (mensagem) => {
      $q.notify({
        message: mensagem,
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const listarFerramentas = async (page = 1, rowsPerPage = 12) => {
      await store.state.org.unidadeData.id;
      try {
        disable.value = true;
        let resposta = await store.dispatch("fer/listarFerramentas", {
          unidadeId: store.state.org.unidadeData.id,
          page,
          perPage: rowsPerPage,
          filtro: filtraFerramenta.value,
          categoria: grupoFiltro.value.nome,
          grupo: subGrupoFiltro.value.nome,
          patrimonio: patrimonio.value,
        });

        listaFerramentas.value = resposta.resposta.data.result.data;
        pagination.value.page = resposta.resposta.data.result.current_page;
        pagination.value.rowsPerPage = resposta.resposta.data.result.per_page;
        pagination.value.rowsNumber = resposta.resposta.data.result.total;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const handleRequest = async () => {
      listarFerramentas(pagination.value.page, pagination.value.rowsPerPage);
    };

    const proximo = async () => {
      pagination.value.page++;
      listarFerramentas(pagination.value.page);
    };

    const voltar = async () => {
      pagination.value.page--;
      listarFerramentas(pagination.value.page);
    };

    const movimentarStatus = async (id) => {
      try {
        await store.dispatch("fer/movimentaStatus", {
          uuid: id,
          status: "disponivel",
          observacao: "Modificação de status automatica",
        });
        $q.notify({
          message: "Status movimentado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarFerramentas();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao movimentar status",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    watch(
      () => store.state.org.unidadeData.id,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => filtraFerramenta.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentas(
          pagination.value.page,
          pagination.value.rowsPerPage,
          filtraFerramenta.value
        );
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      emitir.value.unidade = store.state.org.unidadeData;
    };

    onMounted(() => {
      getUnidade();
      listarFerramentas();
    });

    let criar = async () => {
      if (ferramenta.value.nome == "") {
        $q.notify({
          message: "O nome da ferramenta não foi informado.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let sucess = await myForm.value.validate();
      if (!sucess) {
        return;
      }
      try {
        const resposta = await store.dispatch("fer/criarFerramenta", {
          unidadeId: store.state.org.unidadeData.id,
          nome: ferramenta.value.nome,
          descricao: ferramenta.value.descricao,
          patrimonio: ferramenta.value.patrimonio,
          permanencia: ferramenta.value.permanencia,
          preco: ferramenta.value?.preco.split(",").join("."),
          grupo: subGrupo.value.uuid,
          origem: ferramenta.value.origem,
          serie: ferramenta.value.serie,
          documento: ferramenta.value.documento,
          fornecedorId: ferramenta.value.fornecedorId,
          responsavelId: ferramenta.value.responsavelId,
          tipo_documento: ferramenta.value.tipo_documento,
          valor_locacao: ferramenta.value?.valorLocacao.split(",").join("."),
        });
        id.value = resposta.resposta.data.result.uuid;
        upar.value++;
        atualizar.value++;
        resetar.value++;
        mensagem("Ferramenta cadastrada com sucesso!");

        reset();
        onReset();

        listarFerramentas();
      } catch (e) {
        $q.notify({
          message: e.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      ferramenta.value = {};
    };

    const receberDadosRemoverFerramenta = (ferramenta) => {
      ferramentaExcluir.value = ferramenta;
      FerramentaExcluirModal.value = true;
    };

    const receberDadosGrupoFiltro = async (value) => {
      if (value === "") {
        subGrupoFiltro.value = {
          uuid: "",
          nome: "",
          categoria_uuid: "",
          descricao: "",
        };
        grupoFiltro.value = { descricao: "", uuid: "", nome: "" };
        return;
      }
      grupoFiltro.value = value;
    };

    const receberDadosSubGrupoFiltro = async (value) => {
      if (value === "") {
        subGrupoFiltro.value = {
          uuid: "",
          nome: "",
          categoria_uuid: "",
          descricao: "",
        };
        return;
      }
      subGrupoFiltro.value = value;
    };

    const getUnidadee = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidadee);

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    watch(
      () => grupoFiltro.value,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => subGrupoFiltro.value,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => patrimonio.value,
      () => {
        listarFerramentas();
      }
    );

    return {
      filter: ref(""),
      criar,
      editar,
      deletar,
      deletarImagem,
      myForm,
      listaFerramentas,
      listarFerramentas,
      voltar,
      emitir,
      getUnidade,
      ferramenta,
      receberDadosGrupo,
      receberDadosFornecedor,
      receberDadosFuncionario,
      proximo,
      atualizar,
      upload,
      mensagem,
      disable,
      upar,
      confirm,
      filtraFerramenta,
      handleRequest,
      movimentarStatus,
      id,
      receberDadosSubGrupo,
      pagination,
      subGrupo,
      resetar,
      receberDadosDocumento,
      receberDadosRemoverFerramenta,
      unidade,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      columns: [
        { name: "descricao", label: "Descrição", field: "descricao" },
        { name: "nome", label: "nome", field: "nome" },
        { name: "patimonio", label: "patimonio", field: "patrimonio" },
        { name: "preco", label: "preco", field: "preco" },
        { name: "status", label: "status", field: "status" },
        {
          name: "tempoPermanencia",
          label: "tempoPermanencia",
          field: "tempoPermanencia",
        },
        { name: "url", label: "url", field: "url" },
        { name: "uuid", label: "uuid", field: "uuid" },
      ],
      grupoFiltro,
      subGrupoFiltro,
      receberDadosGrupoFiltro,
      receberDadosSubGrupoFiltro,
      patrimonio,
      ferramentaExcluir,
      FerramentaExcluirModal,
    };
  },
};
</script>

<style scoped>
.my-card {
  padding: 8px;
  min-height: 360px;
}

.my-card .q-img {
  border-top: 1px solid #b4b4b4;
}
a {
  text-decoration: none;
}

.align {
  align-items: center;
}

.border-img {
  border: 1px solid #b4b4b4;
  border-radius: 5px;
  max-height: 176px;
  min-height: 176px;
  width: 100%;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.cursor {
  cursor: pointer;
}

@media (max-width: 1029px) {
  .margin-top {
    margin-top: 20px;
  }

  .mobile2 div {
    width: 100%;
  }
}

@media (max-width: 1304px) {
  .mobile2 {
    width: 100%;
  }
}
</style>
